/*
teaserVideos

plays video on mouseover of news image e.g. https://www.gww-netz.de/de/aktuelles/aktuelles-archiv.html

tobias.wolf@wagnerwagner.de
*/


(function () {
  if (!isTouchDevice()) {
    // elements
    const teaserImageWithVideoElements = document.querySelectorAll('.aktuelles-teaser__image[data-video], .neuigkeiten-teaser__image[data-video]');


    // function

    function updateVisibility(videoElement) {
      if (videoElement) {
        if (videoElement.paused === true) {
          videoElement.classList.remove('is-visible');
        } else {
          videoElement.classList.add('is-visible');
        }
      }
    }

    function createVideoElement(element) {
      const videoElement = document.createElement('video');
      videoElement.src = element.dataset.video;
      videoElement.muted = true;
      videoElement.loop = true;
      videoElement.crossorigin = 'anonymous';
      videoElement.playsinline = true;
      videoElement.preload = 'metadata';
      element.appendChild(videoElement);
      videoElement.addEventListener('play', () => {
        updateVisibility(videoElement);
      });
      videoElement.addEventListener('pause', () => {
        updateVisibility(videoElement);
      });
      return videoElement;
    }

    function startVideo(videoElement) {
      if (videoElement) {
        videoElement.currentTime = 0;
        videoElement.play();
      }
    }

    function stopVideo(videoElement) {
      if (videoElement) {
        videoElement.pause();
      }
    }


    for (let i = 0; i <= teaserImageWithVideoElements.length; i++) {
      const teaserImageWithVideoElement = teaserImageWithVideoElements[i];
      const parentLinks = getParents(teaserImageWithVideoElement, 'a');

      if (parentLinks[0]) {
        const parentLinkElement = parentLinks[0];
        const videoElement = createVideoElement(teaserImageWithVideoElement);
        parentLinkElement.addEventListener('focus', (event) => {
          const videoElement = event.target.querySelector('video');
          startVideo(videoElement);
        });
        parentLinkElement.addEventListener('blur', (event) => {
          const videoElement = event.target.querySelector('video');
          stopVideo(videoElement);
        });
        parentLinkElement.addEventListener('mouseenter', (event) => {
          const videoElement = event.target.querySelector('video');
          startVideo(videoElement);
        });
        parentLinkElement.addEventListener('mouseleave', (event) => {
          const videoElement = event.target.querySelector('video');
          stopVideo(videoElement);
        });
      }
    }
  }
}());
